// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { Tag } from "antd";
import { USER_WORKFLOW_STATUS } from "../../../../utils/Constant";

type UserTypeProps = {
  status?: string;
};

const UserStatusTag: React.FunctionComponent<UserTypeProps> = (
  props: UserTypeProps
) => {
  const { status } = props;

  return status ? (
    <Tag color={USER_WORKFLOW_STATUS[status].color}>
      {USER_WORKFLOW_STATUS[status].label}
    </Tag>
  ) : null;
};

export default UserStatusTag;
